import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators'

import { CookieService } from 'ngx-cookie-service'
import type { User } from '@/app/helpers/fake-backend'

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User | null = null

  public readonly authSessionKey = '_REBACK_AUTH_SESSION_KEY_'
  private cookieService = inject(CookieService)

  constructor(private http: HttpClient) { }

  logout(): void {
    // remove user from cookie to log user out
    this.removeSession()
    this.user = null
  }

  get session(): any {
    const token = localStorage.getItem('token');
    return token ? { token } : null;
  }

  saveSession(token: string): void { this.cookieService.set(this.authSessionKey, token) }

  removeSession(): void { this.cookieService.delete(this.authSessionKey) }
}
